/* unplugin-vue-components disabled */import { render } from "./UserModify.vue?vue&type=template&id=21de63de&scoped=true"
import script from "./UserModify.vue?vue&type=script&lang=js"
export * from "./UserModify.vue?vue&type=script&lang=js"

import "./UserModify.vue?vue&type=style&index=0&id=21de63de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21de63de"]])

export default __exports__